/**
 * One page-scroll lock shared by everything that covers the page on a phone (sheets,
 * full-screen layers). `position: fixed` on <body> is the only lock iOS Safari respects;
 * the scroll position is put back exactly when the last layer closes.
 */
let lockCount = 0;
let lockedScrollY = 0;

export const lockBody = () => {
  if (lockCount++ > 0) return;
  lockedScrollY = window.scrollY;
  const s = document.body.style;
  s.position = 'fixed';
  s.top = `-${lockedScrollY}px`;
  s.left = '0';
  s.right = '0';
  s.width = '100%';
};

export const unlockBody = () => {
  if (lockCount === 0 || --lockCount > 0) return;
  const s = document.body.style;
  s.position = '';
  s.top = '';
  s.left = '';
  s.right = '';
  s.width = '';
  window.scrollTo(0, lockedScrollY);
};
